import { useEffect } from "react";
import { useLocation } from "wouter";
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";
import { recoverFromStaleShell } from "@/lib/pwa-update";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();
  const [location] = useLocation();

  // Landing on the catch-all 404 for a route the current code knows about is a
  // strong signal of a stale cached app shell after a new deploy. Try to update
  // the service worker and refresh onto the latest version; genuine 404s (no
  // update available) are left to render normally. Keyed to the location so a
  // transition to a different unmatched path also attempts recovery.
  useEffect(() => {
    return recoverFromStaleShell("not-found:" + location);
  }, [location]);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md mx-4">
        <CardContent className="pt-6">
          <div className="flex mb-4 gap-2">
            <AlertCircle className="h-8 w-8 text-red-500" />
            <h1 className="text-2xl font-bold text-gray-900">{t("authPages.notFoundTitle")}</h1>
          </div>

          <p className="mt-4 text-sm text-gray-600">
            {t("authPages.notFoundDesc")}
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
